export default __webpack_public_path__ + "static/media/expert2.df838e45.jpg";